import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appOtpMask]',
  standalone: true
})
export class OtpMaskDirective {
  @Input() maskChar: string = '*'; // Default to bullet character
  private originalValue: string = ''; // Store the original value internally

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    this.originalValue = input.value;
    this.applyMask(input);
  }

  @HostListener('focus', ['$event']) onFocus(event: Event) {
    const input = event.target as HTMLInputElement;
    input.value = this.originalValue;
  }

  @HostListener('blur', ['$event']) onBlur(event: Event) {
    const input = event.target as HTMLInputElement;
    this.applyMask(input);
  }

  private applyMask(input: HTMLInputElement) {
    if (this.originalValue) {
      input.value = this.maskChar.repeat(this.originalValue.length);
    } else {
      input.value = '';
    }
  }
}